module.exports = __webpack_public_path__ + "static/img/VIN_img.02f7818.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/VIN_img.webp
// module id = sZr7
// module chunks = 2